var NumberFormatterFormat = {
  Default: "default",
  GBP: "GBP",
  USD: "USD",
  EUR: "EUR",
  Percentage: "percentage",
  Kg: "kg"
};
var DateFormatterFormat = {
  Default: "default",
  Short: "short",
  Medium: "medium",
  Long: "long",
  MonthYear: "monthYear"
};
var DateTimeFormatterFormat = {
  Default: "default",
  Short: "short",
  Medium: "medium",
  Long: "long"
};
var TimeFormatterFormat = {
  Default: "default",
  TwelveHour: "12hour",
  TwentyFourHour: "24hour"
};

export { DateFormatterFormat, DateTimeFormatterFormat, NumberFormatterFormat, TimeFormatterFormat };
